import * as React from "react";
import {Button, Input} from "antd";
import {BusinessDto} from "../../../gen/client";
import {MenuItemModifier, MenuItemModifierEntry, MenuNode} from "../../../domain/Menu";
import styles from "./MenuItemSizes.module.scss";
import {uuid} from "../../../util/Utils";
import {DeleteOutlined} from "@ant-design/icons";
import Price from "../../Price";

interface MenuItemModifiersProps {
  business: BusinessDto;
  item: MenuNode;
  onItemUpdate: (item: Partial<MenuNode>) => void;
}

export default function MenuItemModifiers({item, business, onItemUpdate}: MenuItemModifiersProps) {
  function addModifier() {
    const updated = [...item.modifiers, new MenuItemModifier(uuid(), '', [], item.modifiers.length)]
    onItemUpdate({modifiers: updated});
  }

  function removeModifier(idx: number) {
    const updated = [...item.modifiers];
    updated.splice(idx, 1);
    updated.sort((a, b) => a.sequence - b.sequence).forEach((e, i) => {
      e.sequence = i;
    })
    onItemUpdate({modifiers: updated});
  }

  function onModifierNameChange(name: string, idx: number) {
    const updated = [...item.modifiers];
    updated[idx].name = name;
    onItemUpdate({modifiers: updated});
  }

  function onEntryNameChange(name: string, modIdx: number, entryIdx: number) {
    const updated = [...item.modifiers];
    updated[modIdx].entries[entryIdx].name = name;
    onItemUpdate({modifiers: updated});
  }

  function onEntryPriceChange(price: string, modIdx: number, entryIdx: number) {
    const updated = [...item.modifiers];
    updated[modIdx].entries[entryIdx].price = price;
    onItemUpdate({modifiers: updated});
  }

  function addEntry(idx: number) {
    const updated = [...item.modifiers];
    updated[idx].entries = [...updated[idx].entries, new MenuItemModifierEntry(uuid(), '', null, updated[idx].entries.length)];
    onItemUpdate({modifiers: updated});
  }

  function removeEntry(modIdx: number, entryIdx: number) {
    const updated = [...item.modifiers];
    updated[modIdx].entries.splice(entryIdx, 1);
    updated[modIdx].entries.sort((a, b) => a.sequence - b.sequence).forEach((e, i) => {
      e.sequence = i;
    })
    onItemUpdate({modifiers: updated});
  }
   
  return (
    <div className={styles.modifiers}>
      <ul>
        {item.modifiers && item.modifiers.map((modifier, idx) => (
          <li key={`${modifier.id}`}>
            <div className={styles.modNameDelete}>
              <Input className={styles.sizeInput} size="large" defaultValue={modifier.name} placeholder={`Modifier Group ${idx + 1}`} onBlur={(ev) => onModifierNameChange(ev.target.value, idx)} />
              <span className={styles.remove}>
                <DeleteOutlined onClick={() => removeModifier(idx)} />
              </span>
            </div>

            {modifier.entries.length > 0 &&
            <div className={styles.sizes}>
              <ul>
                {modifier.entries.map((entry, eidx) => (<li key={`${entry.id}`}>
                  <Input className={styles.sizeInput} size="large" defaultValue={entry.name} placeholder={`Modifier ${eidx + 1}`} onBlur={(ev) => onEntryNameChange(ev.target.value, idx, eidx)} />
                  <Price business={business} currency={business?.config.currency} edit placeholder={`Price ${eidx + 1}`} value={entry.price ? entry.price.toString() : ''} onChangeText={(p) => onEntryPriceChange(p, idx, eidx)} />
                  <span className={styles.remove}>
                    <DeleteOutlined onClick={() => removeEntry(idx, eidx)} />
                  </span>
                </li>))}
              </ul>
            </div>}

            <Button onClick={() => addEntry(idx)} style={{marginTop: '15px', marginLeft: '15px'}}>
              + Modifier
            </Button>
          </li>
        ))}
      </ul>
      <Button onClick={addModifier} style={{marginRight: "auto", marginTop: '15px'}}>
        + Add Modifier Group
      </Button>
    </div>
  );
}
